export default "__VITE_ASSET__CMwKbQ_v__"